import type { GridSortModel, GridSortItem } from "@mui/x-data-grid";

type TSortDirection = "asc" | "desc";
export type TSortObject = Record<string, TSortDirection>;
export type TBackendSortItem = {
  field: string;
  direction: TSortDirection;
};

export function serializeSortModel(model: GridSortModel): string {
  return model
    .filter(
      (item): item is GridSortItem & { sort: TSortDirection } =>
        !!item.sort && !!item.field,
    )
    .map((item) => `${item.field}:${item.sort}`)
    .join(",");
}

export function parseSortParam(
  param?: string | string[] | null,
): GridSortModel {
  if (!param) return [];

  const chunks = Array.isArray(param) ? param : [param];

  return chunks
    .map((chunk) => chunk.trim())
    .filter(Boolean)
    .map((chunk) => {
      const [fieldRaw, dirRaw] = chunk.split(":");
      const field = fieldRaw?.trim();
      const dir = dirRaw?.trim();

      if (!field) return null;

      return { field, sort: dir === "desc" ? "desc" : "asc" };
    })
    .filter(Boolean) as GridSortModel;
}

export function sortModelToObject(
  model: GridSortModel,
): TSortObject | undefined {
  const entries = model
    .filter(
      (item): item is GridSortItem & { sort: TSortDirection } =>
        !!item.sort && !!item.field,
    )
    .map((item) => [item.field, item.sort] as const);

  return entries.length ? Object.fromEntries(entries) : undefined;
}

export function sortModelToArray(
  model: GridSortModel,
): TBackendSortItem[] | undefined {
  const items = model
    .filter(
      (item): item is GridSortItem & { sort: TSortDirection } =>
        !!item.sort && !!item.field,
    )
    .map((item) => ({
      field: item.field,
      direction: item.sort,
    }));

  return items.length ? items : undefined;
}
